import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.map";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { useCallback, useEffect, useState } from "react";
import _debounce from "lodash/debounce";
import analytics from "web/script/analytics/analytics";
import requester from "web/script/modules/requester";
import userProfiler from "web/script/modules/userprofiler";
import logging from "web/script/utils/logging";
import url from "web/script/utils/url";
/**
 * @type {Map<string, boolean>}
 */

var statusCache = new Map();
/** @typedef {{promise: Promise<boolean>, resolve?: (ret: boolean) => void, reject?: (err: Error) => void, saving: bool}} FetchCacheItem */

/**
 * @type {Map<string, FetchCacheItem>}
 */

var fetchCache = new Map();
/**
 * @type {Set<string>}
 */

var fetchQueue = new Set();
/**
 * @param {string} productID
 * @returns {[FetchCacheItem, boolean]}
 */

function createFetchCacheItem(productID) {
  // Shouldn't happen, but just in case
  if (fetchCache.has(productID)) {
    return fetchCache.get(productID);
  }

  var cachedFetch = {}; // This cannot happen in the initialiser for `cachedFetch` because object
  //  properties are evaluated before the object is created which results in
  //  the `new Promise` callback being invoked before the reference it needs to
  //  modify is available.
  // This is pretty confusing behaviour and took a while to debug :(

  cachedFetch.promise = new Promise(function (resolve, reject) {
    cachedFetch.resolve = resolve;
    cachedFetch.reject = reject;
  });
  fetchCache.set(productID, cachedFetch);
  return cachedFetch;
}

export { statusCache as __statusCache, fetchCache as __fetchCache, fetchQueue as __fetchQueue, createFetchCacheItem as __createFetchCacheItem };
/**
 * @param {string[]} productIDs
 * @returns {Promise<void>}
 */

function fetchStatuses(_x) {
  return _fetchStatuses.apply(this, arguments);
}

function _fetchStatuses() {
  _fetchStatuses = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(productIDs) {
    var data, query, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, productID, cachedFetch, _i2, _Object$keys, _productID, _cachedFetch, isSaved, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _productID2, _cachedFetch2;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            query = url.toURLSearchParams({
              // TODO: There's a limit to the size this request can be, we should
              //        split it up into multiple requests if it's too long
              product_id: productIDs
            });
            _context2.next = 4;
            return requester.get("/services/pins/", query);

          case 4:
            data = _context2.sent;
            _context2.next = 39;
            break;

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            _context2.prev = 12;
            _iterator2 = productIDs[Symbol.iterator]();

          case 14:
            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
              _context2.next = 24;
              break;
            }

            productID = _step2.value;
            cachedFetch = fetchCache.get(productID);

            if (!(!cachedFetch || cachedFetch.saving)) {
              _context2.next = 19;
              break;
            }

            return _context2.abrupt("continue", 21);

          case 19:
            if (cachedFetch.reject) {
              cachedFetch.reject(_context2.t0);
            }

            fetchCache.delete(productID);

          case 21:
            _iteratorNormalCompletion2 = true;
            _context2.next = 14;
            break;

          case 24:
            _context2.next = 30;
            break;

          case 26:
            _context2.prev = 26;
            _context2.t1 = _context2["catch"](12);
            _didIteratorError2 = true;
            _iteratorError2 = _context2.t1;

          case 30:
            _context2.prev = 30;
            _context2.prev = 31;

            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }

          case 33:
            _context2.prev = 33;

            if (!_didIteratorError2) {
              _context2.next = 36;
              break;
            }

            throw _iteratorError2;

          case 36:
            return _context2.finish(33);

          case 37:
            return _context2.finish(30);

          case 38:
            throw _context2.t0;

          case 39:
            _i2 = 0, _Object$keys = Object.keys(data.pin_mapping);

          case 40:
            if (!(_i2 < _Object$keys.length)) {
              _context2.next = 52;
              break;
            }

            _productID = _Object$keys[_i2];
            _cachedFetch = fetchCache.get(_productID);

            if (!(_cachedFetch && _cachedFetch.saving)) {
              _context2.next = 45;
              break;
            }

            return _context2.abrupt("continue", 49);

          case 45:
            isSaved = data.pin_mapping[_productID];
            statusCache.set(_productID, isSaved);

            if (_cachedFetch && _cachedFetch.resolve) {
              _cachedFetch.resolve(isSaved);
            }

            fetchCache.delete(_productID);

          case 49:
            _i2++;
            _context2.next = 40;
            break;

          case 52:
            _iteratorNormalCompletion3 = true;
            _didIteratorError3 = false;
            _iteratorError3 = undefined;
            _context2.prev = 55;
            _iterator3 = productIDs[Symbol.iterator]();

          case 57:
            if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
              _context2.next = 67;
              break;
            }

            _productID2 = _step3.value;
            _cachedFetch2 = fetchCache.get(_productID2);

            if (!(!_cachedFetch2 || _cachedFetch2.saving)) {
              _context2.next = 62;
              break;
            }

            return _context2.abrupt("continue", 64);

          case 62:
            if (_cachedFetch2.reject) {
              _cachedFetch2.reject(new Error("Server response did not include product \"".concat(_productID2, "!")));
            }

            fetchCache.delete(_productID2);

          case 64:
            _iteratorNormalCompletion3 = true;
            _context2.next = 57;
            break;

          case 67:
            _context2.next = 73;
            break;

          case 69:
            _context2.prev = 69;
            _context2.t2 = _context2["catch"](55);
            _didIteratorError3 = true;
            _iteratorError3 = _context2.t2;

          case 73:
            _context2.prev = 73;
            _context2.prev = 74;

            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }

          case 76:
            _context2.prev = 76;

            if (!_didIteratorError3) {
              _context2.next = 79;
              break;
            }

            throw _iteratorError3;

          case 79:
            return _context2.finish(76);

          case 80:
            return _context2.finish(73);

          case 81:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7], [12, 26, 30, 38], [31,, 33, 37], [55, 69, 73, 81], [74,, 76, 80]]);
  }));
  return _fetchStatuses.apply(this, arguments);
}

var runQueue = _debounce(function () {
  if (!fetchQueue.size) {
    return;
  }

  fetchStatuses(Array.from(fetchQueue)).catch(function (err) {
    return logging.error(err, "Failed to run the fetch queue");
  });
  fetchQueue.clear();
}, 50);
/**
 * Asks the save for later system to prefetch a number of product IDs and cache
 *  the results.
 * Useful for situations where you know you're going to render a bunch of
 *  buttons and want to start fetching them all immediately.
 * As with all hooks, you should not dynamically generate the productIDs
 *  parameter or it'll run the effect every single render.
 * @param {string[]} productIDs The products in question
 * @returns {void}
 */


export function useSFLPrefetch(productIDs) {
  useEffect(function () {
    if (!userProfiler.isLoggedIn()) {
      return;
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = productIDs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var productID = _step.value;

        if (statusCache.has(productID) || fetchCache.has(productID)) {
          continue;
        }

        fetchQueue.add(productID);

        var _createFetchCacheItem = createFetchCacheItem(productID),
            promise = _createFetchCacheItem.promise; // This function doesn't care if any of these promises fail but the
        //  runtime gets upset if you don't catch rejected promises.
        // In some cases, `useSaveForLater` will _also_ catch this error and
        //  report, which could be annoying - but generally the logging
        //  module should catch this and only report it once.


        promise.catch(logging.error);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    runQueue();
  }, [productIDs]);
}

function actualToggleSave(_x2) {
  return _actualToggleSave.apply(this, arguments);
}
/**
 * @param {string} productID
 * @returns {Promise<boolean>}
 */


function _actualToggleSave() {
  _actualToggleSave = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(productID) {
    var response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return requester("/services/pins/", {
              method: "POST",
              body: {
                product_id: productID
              }
            });

          case 2:
            response = _context3.sent;
            fetchCache.delete(productID);

            if (!(response.status === 204)) {
              _context3.next = 9;
              break;
            }

            statusCache.set(productID, false);
            return _context3.abrupt("return", false);

          case 9:
            if (!(response.status === 201)) {
              _context3.next = 12;
              break;
            }

            statusCache.set(productID, true);
            return _context3.abrupt("return", true);

          case 12:
            throw new Error("Could not save/un-save product with id: ".concat(productID));

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _actualToggleSave.apply(this, arguments);
}

function toggleSave(productID) {
  var cachedFetch = fetchCache.get(productID) || {}; // If we're already saving this pin, don't do it again
  // Otherwise, we want to take over this fetch mid-flight and change the
  //  result to be the result of the user's action.

  if (cachedFetch.saving) {
    return cachedFetch.promise;
  }

  cachedFetch.saving = true;
  cachedFetch.promise = actualToggleSave(productID);
  var originalResolve = cachedFetch.resolve;
  var originalReject = cachedFetch.reject;
  delete cachedFetch.resolve;
  delete cachedFetch.reject;
  fetchCache.set(productID, cachedFetch);
  return cachedFetch.promise.then(function (result) {
    if (originalResolve) {
      originalResolve(result);
    }

    return result;
  }).catch(function (err) {
    if (originalReject) {
      originalReject(err);
    }

    throw err;
  });
}

function getStatus(_x3) {
  return _getStatus.apply(this, arguments);
}

function _getStatus() {
  _getStatus = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(productID) {
    var initialState,
        cachedStatus,
        cachedFetch,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            initialState = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : null;

            if (!fetchCache.has(productID)) {
              _context4.next = 5;
              break;
            }

            _context4.next = 4;
            return fetchCache.get(productID).promise;

          case 4:
            return _context4.abrupt("return", _context4.sent);

          case 5:
            cachedStatus = statusCache.get(productID);

            if (!(cachedStatus != null)) {
              _context4.next = 10;
              break;
            }

            return _context4.abrupt("return", cachedStatus);

          case 10:
            if (!(initialState != null)) {
              _context4.next = 13;
              break;
            }

            statusCache.set(productID, initialState);
            return _context4.abrupt("return", initialState);

          case 13:
            cachedFetch = createFetchCacheItem(productID);
            fetchQueue.add(productID);
            runQueue();
            _context4.next = 18;
            return cachedFetch.promise;

          case 18:
            return _context4.abrupt("return", _context4.sent);

          case 19:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getStatus.apply(this, arguments);
}

var eventLabels = {
  feed: "product_card",
  pdp: "product_page",
  oos: "stock_alert"
};
/**
 * Get the right analytics event label for this pagesource
 * @param {keyof eventLabels} pageSource
 * @returns {string}
 */

export function getAnalyticsEventLabel(pageSource) {
  return eventLabels[pageSource];
}
/**
 * A hook for creating a save for later button.
 * @param {string} productID
 * @param {keyof eventLabels} pageSource
 * @param {boolean | null} initialState
 * @returns {[boolean | null, boolean, () => Promise<boolean>]}
 */

export function useSaveForLater(productID, pageSource) {
  var initialState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      isSaved = _useState2[0],
      setIsSaved = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isSaving = _useState6[0],
      setIsSaving = _useState6[1]; // Enforce productId is always a string.


  productID = productID ? productID.toString() : productID;
  useEffect(function () {
    if (!userProfiler.isLoggedIn() || !productID) {
      return;
    }

    setIsSaved(null);
    setLoading(true);
    getStatus(productID, initialState).then(setIsSaved).catch(function (err) {
      return logging.error(err, "Failed to get initial save state for product %s:", productID);
    }).then(function () {
      return setLoading(false);
    });
  }, [productID, initialState]);
  var toggleState = useCallback(
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var eventLabel, newState;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!userProfiler.isLoggedIn() || !productID)) {
              _context.next = 2;
              break;
            }

            throw new Error("Cannot toggle save state!");

          case 2:
            eventLabel = getAnalyticsEventLabel(pageSource);
            setLoading(true);
            _context.prev = 4;
            // Transitioning from unsaved to saved.
            setIsSaving(!isSaved);
            _context.next = 8;
            return toggleSave(productID);

          case 8:
            newState = _context.sent;
            setIsSaved(newState);
            setIsSaving(false);
            _context.next = 17;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](4);
            // Still want to log the intent, but can't work out from response if
            //  it was an add or remove - get this data from the cache instead
            // (this won't be accurate if the page has not been refreshed since
            //  last add/remove, but is the best we can do here).
            newState = !statusCache.get(productID); // TODO: Tell the user? Trigger another fetch to see if it actually
            //        went through or not? Does this happen enough to care?

            logging.error(_context.t0, "Could not toggle save state for product %s:");

          case 17:
            setLoading(false);

            if (newState) {
              analytics.event("save_for_later", "add_item", eventLabel);
            } else {
              analytics.event("save_for_later", "remove_item", eventLabel);
            }

            return _context.abrupt("return", undefined);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 13]]);
  })), [productID, pageSource, isSaved]);
  return [isSaved, loading, toggleState, isSaving];
}
/**
 * A hook finding out if a product is saved for later
 * TODO: This will not update if the user saves a product.
 * @param {string} productID
 * @param {boolean | null} initialState
 * @returns {[boolean | null, boolean]}
 */

export function useGetSaveForLaterStatus(productID) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      isSaved = _useState8[0],
      setIsSaved = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      loading = _useState10[0],
      setLoading = _useState10[1];

  useEffect(function () {
    if (!userProfiler.isLoggedIn() || !productID) {
      return;
    }

    setIsSaved(null);
    setLoading(true);
    getStatus(productID, initialState).then(setIsSaved).catch(function (err) {
      return logging.error(err, "Failed to get initial save state for product %s:", productID);
    }).then(function () {
      return setLoading(false);
    });
  }, [productID, initialState]);
  return [isSaved, loading];
}